import React, { FC } from 'react'
import { useLocalization } from '@components/Localization'
import { ringSizes } from '@lib/ringSizes'
import {
  Listbox as ListboxEl,
  Span,
  Box,
  Flex,
  Text,
  theme,
  linkStyles,
  small
} from '@components/gassan-ui'
import styled from 'styled-components'
import Mobile from './Mobile'
import LocalizedLink from '@components/Localization/LocalizedLink'

type Props = {
  onRequestClose: () => void
  onSelectSize: (size: string) => void
  onConfirm: () => void
  selectedSize: string
  showMobileSizePicker: boolean
  sizeHasError: boolean
}

const InfoLink = styled.a`
  ${small};
  ${linkStyles};
  color: ${p => p.theme.colors.shades[500]};
`

const Listbox = styled(ListboxEl)`
  background: red;
`

export const getSizes = () => {
  let sizes = []
  for (let i = 1; i < ringSizes.length; i++) {
    const value = `${ringSizes[i]}mm`
    sizes.push({ label: value, value: value })
  }
  return sizes
}

const SelectSize: FC<Props> = ({
  onRequestClose,
  onSelectSize,
  onConfirm,
  selectedSize,
  showMobileSizePicker,
  sizeHasError
}) => {
  const { lang, messages } = useLocalization()
  return (
    <>
      <Box display={{ _: 'none', large: 'block' }} width="100%">
        <Flex
          justifyContent="space-between"
          alignItems="center"
          pb="0.5rem"
          mb="1rem"
          borderBottom={`1px solid ${theme.colors.shades[200]}`}
        >
          <Text
            variant="small"
            mb="0"
            color={sizeHasError ? theme.colors.error : 'inherit'}
            as="div"
            width="50%"
          >
            {lang === 'nl' ? 'Kies een maat' : 'Pick a size'}
          </Text>
          <LocalizedLink href="/[...slug]" as={`/${messages.urlSlugItems.sizeInformation}`}>
            <InfoLink target="_blank">
              {lang === 'nl' ? 'Maat informatie' : 'Size information'}
            </InfoLink>
          </LocalizedLink>
        </Flex>
        <Box pb="1rem" borderBottom={`1px solid ${theme.colors.shades[200]}`}>
          <Listbox
            value={selectedSize}
            onChange={size => onSelectSize(size)}
            items={[
              {
                label: lang === 'nl' ? 'Weet ik niet' : "I don't know",
                value: 'dont-know'
              },
              ...getSizes()
            ]}
            hasError={sizeHasError}
          >
            {selectedSize === null ? (
              <Span color="shades.500">{lang === 'nl' ? 'Kies een maat' : 'Select a size'}</Span>
            ) : selectedSize === 'dont-know' ? (
              <Span>{lang === 'nl' ? 'Weet ik niet' : "I don't know"}</Span>
            ) : (
              <>{selectedSize}</>
            )}
          </Listbox>
        </Box>
      </Box>
      {showMobileSizePicker && (
        <Mobile
          onRequestClose={onRequestClose}
          onSelectSize={size => onSelectSize(size)}
          onConfirm={onConfirm}
          selectedSize={selectedSize}
        />
      )}
    </>
  )
}

export default SelectSize
